// Copyright: IQGeo Limited 2010-2022
import myw from 'myWorld/base/core';
import Button from './button';

/**
 * Button with default styles attached
 * @class  PrimaryButton
 * @param  {string} options.text Button label text
 * @param  {function} options.onClick onClick handler
 * @param  {boolean} options.loading Display a loading indicator
 *
 * @example
 * new myw.PrimaryButton({
 *   text: "Hello World",
 *   onClick: function() {},
 *   loading: true
 * })
 *
 * @extends {Button}
 */
myw.PrimaryButton = Button.extend({
    tagName: 'button',
    className: 'primary-btn ui-button ui-corner-all ui-widget'
});

export default myw.PrimaryButton;
